import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import { noop } from 'mojito/utils';
import SearchResultsListImpl from './search-results-list.js';

const { UIView } = MojitoCore.Presentation;

/**
 * Search discovery results grouped by result type.
 *
 * @class SearchResultsList
 * @memberof Mojito.Applications.Sports.Search
 */

/**
 * `SearchResultsList` prop types.
 *
 * @property {object[]} [items = []] - Flat search result items.
 * @property {boolean} [pending = false] - Whether search results are loading.
 * @property {string} [emptyText = ''] - Message shown when the search has no results.
 * @property {Function} [onNavigate] - Called after result navigation.
 *
 * @memberof Mojito.Applications.Sports.Search.SearchResultsList
 */
const propTypes = {
    items: PropTypes.arrayOf(PropTypes.object),
    pending: PropTypes.bool,
    emptyText: PropTypes.string,
    onNavigate: PropTypes.func,
};

const defaultProps = {
    items: [],
    pending: false,
    emptyText: '',
    onNavigate: noop,
};

export default UIView('SearchResultsList', SearchResultsListImpl, propTypes, defaultProps);
